import { axios, API } from "@/imports-files/common/common";
import qs from 'qs';
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class CalandarService extends SendRequest
{
  async getEventData(params)
  {
    // var start = new Date().getTime();
    try {
      const result = await axios.get(API.client.activities.SHOW_ACTIVITIES_DATA,
          {
            params: params,
            headers: this.customHeaderJSON(),
            paramsSerializer: function (params) {
                                                  return qs.stringify(params, {arrayFormat: 'brackets'})
                                                }
          })

    // var end = new Date().getTime();
    // var time = end - start;
    // alert(time);
      return result;

    }
    catch (error)
    {
      return error;
    }
  }
}
